function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, bookmarks) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['global-breakdowns'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const theme = $helpers.useNewMetricsMode() ? `select` : `secondary`;;
        __jade_nodes = __jade_nodes.concat(($attr(`multi-group-by`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-query-entry-section", {
            "key": `${$attr(`selected-query-type`)}-breakdowns`,
            "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes(Object.assign($helpers.getPropertyMenuAttributes(`breakdown`), {
              'can-customize-numeric-buckets': $attr(`can-customize-numeric-buckets`),
              'data-group-id': $attr(`data-group-id`),
              elref: `breakdownSection`,
              'entries': JSON.stringify($helpers.getSegmentEntries()),
              'event-names': JSON.stringify($helpers.getEntryValues(`entries`)),
              'include-custom-properties': $attr(`include-custom-properties`),
              'inline-cohorts-override': $attr(`inline-cohorts-override`),
              'other-group-by-options': $attr(`other-group-by-options`),
              'project-id': $attr(`project-id`),
              'row-draggable': true,
              'row-label-type': $helpers.getNoneRowLabelType(),
              'row-limit': $attr(`multi-group-by-limitation`),
              'row-types': JSON.stringify([$helpers.getSegmentEntryRowType()]),
              'show-special-date-property': $attr(`show-special-date-property`),
              'show-special-dataset-property': $attr(`show-special-dataset-property`),
              'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
              'undraggable-rows': $attr(`group-by-undraggable-rows`),
              'user-id': $attr(`user-id`),
              'workspace-id': $attr(`workspace-id`),
              'disabled': $attr('disable-breakdown')
            }))),
            "on": {
              savedCustomEvent: $helpers.onSavedCustomEvent,
              track: $helpers.captureTracking,
              update: $helpers.updateSegmentEntrySection,
            },
          }));;
          return __jade_nodes
        }).call(this)) : (!$attr(`hide-group-by`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
            "attrs": __vjadeStringifyAttrsIfObj(Object.assign($helpers.getPropertyMenuAttributes(`breakdown`), {
              'type': `segment`,
              'data-group-id': $attr(`data-group-id`),
              'theme': theme,
              'selector-type': `button`,
              'event-names': JSON.stringify($helpers.getEntryValues(`entries`)),
              'label': `Breakdown`,
              'project-has-cohorts': $attr(`project-has-cohorts`),
              'project-id': $attr(`project-id`),
              'removable': $helpers.hasValue(`group-by`),
              'selected': JSON.stringify($attr(`group-by`)),
              'selector-icon': `plus`,
              'user-id': $attr(`user-id`),
              'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
              'inline-cohorts-override': $attr(`inline-cohorts-override`),
              'show-special-dataset-property': $attr(`show-special-dataset-property`),
              'other-group-by-options': $attr(`other-group-by-options`),
              'workspace-id': $attr(`workspace-id`),
            })),
            "dataset": {
              key: `segment`
            },
            "on": {
              remove: () => $helpers.clearSelection(`group-by`),
              select: $helpers.updateGroupBy,
              track: $helpers.captureTracking,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['global-filters'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const menuAttrs = $helpers.getPropertyMenuAttributes();;
        __jade_nodes = __jade_nodes.concat(h("mp-query-entry-section", {
          "key": `${$attr(`selected-query-type`)}-filters`,
          "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes(Object.assign(menuAttrs, {
            elref: `filterSection`,
            'data-group-id': $attr(`data-group-id`),
            'data-groups-enabled': menuAttrs[`data-groups-enabled`] && !$attr(`filter-hide-data-groups`),
            'enable-enhanced-list-filters': $attr(`enable-enhanced-list-filters`),
            'event-names': JSON.stringify($helpers.getEntryValues(`entries`)),
            'entries': JSON.stringify($helpers.getFilterEntries()),
            'inline-cohorts-override': $attr(`inline-cohorts-override`),
            'hide-events': menuAttrs[`hide-events`],
            'project-has-people': menuAttrs[`project-has-people`] && !$attr(`filter-hide-users`),
            'project-id': $attr(`project-id`),
            'row-label-type': $helpers.getNoneRowLabelType(),
            'row-draggable': true,
            'row-types': JSON.stringify([$helpers.getFilterEntryRowType()]),
            'show-special-dataset-property': $attr(`show-special-dataset-property`),
            'show-special-date-property': $attr(`show-special-date-property`),
            'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
            'user-id': $attr(`user-id`),
            'workspace-id': $attr(`workspace-id`),
          }))),
          "on": {
            savedCustomEvent: $helpers.onSavedCustomEvent,
            track: $helpers.captureTracking,
            update: $helpers.updateFilterEntrySection,
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-or-operator-info'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-filter-operator-info': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Matching Any");
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-filter-operator-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: `info`
              }),
            }));
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'max-width': `225px`
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("The \"Any\" operator is deprecated and cannot be changed for this report");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['attribution-control'] = function(disabled = false) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.showAttributionSelector()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'breakdown-attribution-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Attribution type");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'sections': JSON.stringify([{
                  items: $attr(`breakdown-attribution`)
                }]),
                'selected-option': $helpers.getAttributionSelectedOption(),
                'theme': `builder`,
                'menu-width': 200,
                'tab-index': 0,
                'disabled': disabled
              }),
              "on": {
                change: $helpers.updateAttributionSelection
              },
              "props": {
                contextPanelTransform: $helpers.getAttributionContextPanel
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-query-builder': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`data-groups-enabled`) && !$attr(`hide-data-groups-selector`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-data-group-selector", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'project-id': $attr(`project-id`),
              'selected-data-group-id': $attr(`data-group-id`),
              'select-warnings': JSON.stringify($helpers.getDataGroupSelectWarnings()),
              'theme': `builder`,
              'workspace-id': $attr(`workspace-id`),
            }),
            "on": {
              selectDataGroup: $helpers.onDataGroupSelected
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`header`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `header`
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(($attr(`report-header-attrs`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-report-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-query-report-header", {
              "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes($attr(`report-header-attrs`))),
              "props": {
                bookmarks: bookmarks
              },
              "on": {
                actionclick: $helpers.actionClick,
                bookmarkselectoropen: $helpers.propagateEvent,
                bookmarkselect: $helpers.propagateEvent,
                reset: $helpers.propagateEvent,
                save: $helpers.propagateEvent,
                update: $helpers.propagateEvent,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = ($helpers.getHeaderActionItemsSlots());
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("slot", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          name: item.slot,
                          slot: item.slot
                        }),
                      }));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var item = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("slot", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              name: item.slot,
                              slot: item.slot
                            }),
                          }));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-builder-panel': true,
            'for-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`query-type-options`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-type-selection': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `tab-bar`,
                  selected: $attr(`selected-query-type`),
                  options: JSON.stringify($attr(`query-type-options`)),
                }),
                "on": {
                  select: $helpers.onQueryTypeSelected
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("mp-collapsible", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'header-title': $attr(`header-title`),
              'tooltip-text': $attr(`header-tooltip-text`)
            }),
            "on": {
              track: $helpers.captureTracking
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`section-title`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  name: `section-title`,
                  slot: `title`
                }),
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-body': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-query-entry-section", {
                "key": `${$attr(`selected-query-type`)}-entries`,
                "attrs": __vjadeStringifyAttrsIfObj($helpers.serializeAttributes(Object.assign({
                  elref: `entrySection`,
                  'add-entry-label': $attr(`add-entry-label`),
                  'allow-cohort-filter': $attr(`allow-cohort-filter`),
                  'can-customize-numeric-buckets': $attr(`can-customize-numeric-buckets`),
                  'can-rename-step': $attr(`show-entry-rename`),
                  'enable-enhanced-list-filters': $attr(`enable-enhanced-list-filters`),
                  'group-event-behavior': $attr(`can-group-events`) ? `nest` : `none`,
                  'data-group-id': $attr(`data-group-id`),
                  'data-groups-enabled': $attr(`data-groups-enabled`),
                  'date-range': $attr(`date-range`),
                  'disable-clone-entry': $attr(`disable-clone-entry`),
                  'disable-delete-entry': $attr(`disable-delete-entry`),
                  'disable-first-time-event-filters': $attr(`disable-first-time-event-filters`),
                  'disable-add-grouped-event-reason': $attr(`disable-add-grouped-event-reason`),
                  'entries': JSON.stringify($helpers.getEntries(`entries`)),
                  'exclude-autotrack-events': $attr(`exclude-autotrack-events`),
                  'include-custom-properties': $attr(`include-custom-properties`),
                  'inline-cohorts-override': $attr(`inline-cohorts-override`),
                  'is-blocked-people': !$attr(`project-has-people`),
                  'max-data-history-days': $attr(`max-data-history-days`),
                  'metrics-mode': $attr(`metrics-mode`),
                  'project-has-people': $attr(`project-has-people`),
                  'hide-events': true,
                  'project-has-cohorts': $attr(`project-has-cohorts`),
                  'project-id': $attr(`project-id`),
                  'row-draggable': $attr(`entries-draggable`),
                  'row-index-toggleable': $attr(`entry-index-toggleable`),
                  'row-index-toggle-label': $attr(`entry-index-toggle-label`),
                  'row-label-type': $attr(`entry-row-label-type`),
                  'row-limit': $attr(`row-limit`),
                  'row-types': $attr(`row-types`),
                  'show-any-event': $attr(`show-any-event`),
                  'show-sessions': $attr(`show-sessions`),
                  'show-special-dataset-property': $attr(`show-special-dataset-property`),
                  'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
                  'time-display-context': $attr(`time-display-context`),
                  'track-name': $attr(`track-name`),
                  'track-properties': $attr(`track-properties`),
                  'user-id': $attr(`user-id`),
                  'workspace-id': $attr(`workspace-id`),
                  'project-as-of-date': $attr(`project-as-of-date`),
                }, $helpers.getMetricsModeAttributes()))),
                "on": {
                  savedCustomEvent: $helpers.onSavedCustomEvent,
                  track: $helpers.captureTracking,
                  update: ev => $helpers.updateEntrySection(ev, `entries`),
                },
                "class": {
                  'for-new-metrics-mode': $helpers.useNewMetricsMode(),
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean))); /* - TODO: pass this as a custom section */
          __jade_nodes = __jade_nodes.concat(($attr(`show-exclusion-steps`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-collapsible", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'tooltip-text': $attr(`exclusion-step-tooltip-text`),
                'header-title': `Exclusion Steps`,
                'is-closed': $helpers.getEntries(`exclusion-steps`).length === 0,
              }),
              "on": {
                track: $helpers.captureTracking
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-query-body': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-query-entry-section", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'add-entry-label': $attr(`add-exclusion-event-label`),
                    'data-group-id': $attr(`data-group-id`),
                    'data-groups-enabled': $attr(`data-groups-enabled`),
                    'disable-first-time-event-filters': $attr(`disable-first-time-event-filters`),
                    'entries': JSON.stringify($helpers.getEntries(`exclusion-steps`)),
                    'row-draggable': true,
                    'entry-type': `exclusion-event`,
                    'exclude-autotrack-events': $attr(`exclude-autotrack-events`),
                    'include-custom-properties': $attr(`include-custom-properties`),
                    'inline-cohorts-override': $attr(`inline-cohorts-override`),
                    'is-blocked-people': !$attr(`project-has-people`),
                    'num-exclusion-steps': $helpers.getNumExclusionSteps(),
                    'project-has-people': $attr(`project-has-people`),
                    'project-has-cohorts': $attr(`project-has-cohorts`),
                    'project-id': $attr(`project-id`),
                    'track-name': $attr(`track-name`),
                    'workspace-id': $attr(`workspace-id`),
                    'project-as-of-date': $attr(`project-as-of-date`),
                  }),
                  "on": {
                    savedCustomEvent: $helpers.onSavedCustomEvent,
                    track: $helpers.captureTracking,
                    update: ev => $helpers.updateEntrySection(ev, `exclusion-steps`),
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined); /*  allow dynamic sections into the query body */
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-body-sections': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `body-section`
              }),
              "on": {
                'track': $helpers.captureTracking
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!$attr(`hide-filter`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-collapsible", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'header-title': `Filters`,
              }),
              "on": {
                track: $helpers.captureTracking
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-query-body': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($helpers.showFilterOrOperatorInfo()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['filter-or-operator-info'].call(this));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(jade_mixins['global-filters'].call(this));
                __jade_nodes = __jade_nodes.concat(($attr(`enable-filter-attribution`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['attribution-control'].call(this));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!$attr(`hide-group-by`) || $attr(`multi-group-by`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-collapsible", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'header-title': `Breakdowns`,
              }),
              "on": {
                track: $helpers.captureTracking
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-query-body': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['global-breakdowns'].call(this));
                __jade_nodes = __jade_nodes.concat(jade_mixins['attribution-control'].call(this, $attr('disable-breakdown')));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "bookmarks" in locals ? locals.bookmarks : typeof bookmarks !== "undefined" ? bookmarks : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;